$(document).ready(function() {
  
  // Hide the Add to Cart button in Shop the Look overlay
  $(document).on('click','ul.shop-the-look-list li button',function(){
    $(this).parent().hide().next().show();
  });
  $(document).on('change','.shop-the-look-list select',function(){
    $(this).parent().next().find('button').attr('data-cart-add',$(this).val());
  });
  
  if ($(".touchevents .filter-menu").length) {
    
  // Allow multiple filter selection
  var filterArray = [];
  
  // Setup the url
  var filterCollection = $('.filter-menu').attr('id');
  var filterUrl = "";
  
  // Add .selected to each item
  $('.filter-menu li.active').on('click',function() {
    $(this).toggleClass('selected');
    return false;
  });
  
  // Loop through .selected items and build the url
  $('#applyFilter').on('click',function(){
    $('.collection-container.selected').each(function(){
      filterArray.push($(this).find('.collection-name').attr('id'));
    });
    filterUrl = "https://vavavoom.ie/collections/" + filterCollection + "/" + filterArray.join('+');
    //console.log(filterUrl);
    window.location.href = filterUrl;
    return false;
  });
    
  }
  
  
  if ($('body.template-collection').length ) {
    var myLazyLoad = new LazyLoad();
  }
  
  $('.site-nav--has-dropdown>a').on('click',function(event){
    return false;
  });

  // Don't like this but hide the H1 if there is table.accordion on mobile
  if ($('table.accordion').length) {
    $('body').addClass('hasAccordion');
  }
  
  var showCountdown = false;
  var countdownText = "";
  var currentDay = moment().format('dddd');
  var currentHour = moment().format('H');
  var currentMinute = moment().format('mm');
  var currentTime = currentHour + currentMinute;
  var currentTimeInt = parseInt(currentTime);
  var countdownToDate = "";
  var countdownToTime = "";
  if (currentDay == "Monday" && currentTimeInt < 1730) {
    showCountdown = true;
    countdownText = "next day delivery ends in ...";
    countdownToTime = "17:30:00";
  } else if (currentDay == "Tuesday" && currentTimeInt < 1730) {
    showCountdown = true;
    countdownText = "next day delivery ends in ...";
    countdownToTime = "17:30:00";
  } else if (currentDay == "Wednesday" && currentTimeInt < 1730) {
    showCountdown = true;
    countdownText = "next day delivery ends in ...";
    countdownToTime = "17:30:00";
  } else if (currentDay == "Thursday" && currentTimeInt < 1730) {
    showCountdown = true;
    countdownText = "next day delivery ends in ...";
    countdownToTime = "17:30:00";
  } else if (currentDay == "Friday" && currentTimeInt < 1730) {
    showCountdown = true;
    countdownText = "next working day delivery ends in";
    countdownToTime = "17:30:00";
  } else {
    showCountdown = true;
  }
  countdownToDate = moment().format('YYYY/MM/D');
  countdownToDate = countdownToDate + " " + countdownToTime;
  if ($('#countdown .timer').length && showCountdown) {
    $('#countdown').show();
    if(countdownText != "") {
      $('#countdown p').text(countdownText);
    }
    $('#countdown .timer').countdown(countdownToDate, function(event) {
      var totalHours = event.offset.totalDays * 24 + event.offset.hours;
      $(this).html(event.strftime(totalHours + ' hr %M min %S sec'));
    });
  }
  // Match heights
  maxHeight = 0;
  currentItemHeight = 0;
  $('.match-height').each(function() {
    currentItem = $(this);
    currentItemHeight = currentItem.height();
    if (currentItemHeight > maxHeight) {
      maxHeight = currentItemHeight;
    }
    currentItem.css({
      minHeight: maxHeight
    });
  });
  
  $(window).scroll(function(event) {
    var pageScroll = $(window).scrollTop();
    if (pageScroll > 70) {
      $('.feature-notices.popup, .site-header').addClass('active');
    } else {
      $('.feature-notices.popup, .site-header').removeClass('active');
    }
  });
  $("a.icon-hamburger").on("click", function() {
    $(".mobile-navigation").toggleClass("open");
    $(this).toggleClass("active");
    $(".site-header").scrollTop();
    return false;
  });
  $(".mobile-navigation .parent>a").on("click", function() {
    $(this).parent().toggleClass("open");
    return false;
  });
  if ($(".active.selected").length) {
    var filteredByHtml = "";
    $("a.display-filter").addClass("filter-applied").html("Change Filter");
    $(".active.selected").each(function() {
      filteredByHtml += $(this).find("a").html();
      filteredByHtml += ", ";
    });
    $(".filter-summary").html("filtered by:" + filteredByHtml);
  }
  if ($('.display-filter').length) {
    $(".display-filter").on("click", function() {
      $(".filter-menu").toggleClass("active");
    });
  }
  $("a.search").on('click', function() {
    $('form.search').toggleClass('active');
    $('form.search .input-group-field').focus();
    return false;
  });
  /* Add active class to currency drop down */
  $('.currency').on('click', function() {
    $(this).toggleClass("active");
    return false;
  });
  // Create buttons for sizes from select menu  
  if ($('#productSelect').length) {
    var theHtml = "<ul><li class=\"label\">size</li>";
    $("#productSelect option").each(function() {
      if ($(this).val() != "") {
        var theValue = $(this).data("size-option");
        if ($(this).is(":disabled")) {
          theHtml += "<li class=\"soldout\">" + theValue + "</li>";
        } else if ($(this).is(":selected")) {
          theHtml += "<li class=\"available animated selected rubberBand\">" + theValue + "</li>";
        } else {
          theHtml += "<li class=\"available animated\">" + theValue + "</li>";
        }
      }
    });
    theHtml += "</ul>";
    $("#productSelect-buttons").append(theHtml);
  }
  $(document).on("click", "#productSelect-buttons li.available", function() {
    $("#productSelect-buttons li.selected").removeClass("selected");
    $("#productSelect-buttons li.rubberBand").removeClass("rubberBand");
    $(this).addClass("selected rubberBand");
    $("#productSelect option").eq($(this).index() - 1).prop('selected', true);
  });
  setTimeout(function() {
  $('#productSelect-buttons li.selected').trigger('click');
  }, 100);
  /* Image zoom */
  /*
  
  Only use this plugin for non-touch devices. It's crap on mobile and breaks the scrolling of the page
  Manually added data-zoomimage to only load hires image when required.
  
  */
  $("html.no-touchevents body.template-product .slick-carousel .item").each(function(){
    var zoomImage = $(this).find("img").attr("data-zoomimage");
    $(this).zoom({url: zoomImage}); 
  });
  
  /* Homapage mobile nav below carousel */
  $('.quick-links a.parent').on('click', function() {
    var $thisItem = $(this).attr('href');
    $('.quick-links ul').animate({
      opacity: 0,
      left: '-20px'
    }, 300, function() {
      $(this).css({
        display: 'none'
      });
      $($thisItem).css({
        display: 'block',
        left: '20px'
      }).animate({
        opacity: 1,
        left: '0px'
      }, 300);
    });
    return false;
  });
  /* Accordion on standard pages - uses h4 styled in italic followed by ul - complete hack because I don't want client to edit html in Shopify */
  $(document).on('click', 'h4 em', function() {
    $(this).parent().toggleClass('open');
  });
  $('h4:first-child').addClass('open');
  /* Carousels */
  if ($(".slick-carousel").length) {
    $('.slick-carousel').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      asNavFor: '.slick-carousel-nav',
      lazyLoad: 'progressive',
      autoplay: false,
      pauseOnHover: true,
      dots: true
    });
  }
  if ($(".slick-mobile-feature-carousel").length) {
    $('.slick-mobile-feature-carousel').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: true,
      pauseOnHover: true
    });
  }
  if ($(".slick-carousel-nav").length) {
    $('.slick-carousel-nav').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.slick-carousel',
      dots: false,
      focusOnSelect: true,
      infinite: false
    });
  }
  if ($(".slick-carousel-large").length) {
    $('.slick-carousel-large').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      lazyLoad: 'progressive',
      autoplay: true
    });
  }
  if ($(".slick-carousel-categories").length) {
    $('.slick-carousel-categories').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      lazyLoad: 'ondemand',
      autoplay: true
    });
  }
  if ($(".slick-carousel-mini").length) {
    $('.slick-carousel-mini').slick({
      arrows: false,
      autoplay: true,
      lazyLoad: 'progressive',
      dots: false,
      responsive: [{
        breakpoint: 6000,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 800,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      }]
    });
  }
  
  // Delayed scripts beacuse waiting for elements to load
  function delayedScripts() {
    // Delay checking of colours because they are dynamically loaded. Put at end of scripts.
    // Don't use window.load as there are to many other scripts delaying the entire page    
    if ( $("#AddToCartForm").length && $(".selected").length ) {
      $("#AddToCart").prop("disabled",false).removeClass("disabled").find("#AddToCartText").text("add to cart");
    };
    
    $(".main-content").addClass("ready");
  }
  setTimeout(delayedScripts, 500);
  
  // This seems to take longer than any other to load dynamically
  function ExtraDelayedScripts() {
    var wishlistCounter = parseInt($('.topbadge').text());
    if (wishlistCounter > 0) {
      $('.icon-heart').addClass('full bounceIn');
    }
  }
  setTimeout(ExtraDelayedScripts, 3000);
  
  
  
}); // End document ready
